import React from 'react';
// Icon loader for sidebar components
// Dynamically imports all SVGs from ../assets/sidebarcomponents and
// exposes a small component to render them by name.

const icons = {};

// Use webpack's require.context to load SVG files' URLs
try {
  const req = require.context('./', false, /\.svg$/);
  req.keys().forEach((key) => {
    const file = key.replace('./', '');
    const base = file.replace(/\.svg$/i, '');
    const normalized = base.replace(/[^a-z0-9]+/gi, '_').toLowerCase();
    const mod = req(key);
    icons[normalized] = mod && mod.default ? mod.default : mod;
  });
} catch (e) {
  // If require.context is not available during some tests/builds, leave icons empty
  // and log the error in development.
  if (process.env.NODE_ENV !== 'production') console.warn('Could not load sidebar icons:', e.message || e);
}


export function SidebarIcon({ iconName, alt, className, ...props }) {
  if (!iconName) return null;
  const key = String(iconName).replace(/[^a-z0-9]+/gi, '_').toLowerCase();
  const src = icons[key];
  if (!src) {
    if (process.env.NODE_ENV !== 'production') console.warn(`Sidebar icon for "${iconName}" not found (key: ${key}).`);
    return null;
  }
  return <img src={src} alt={alt || iconName} className={className} {...props} />;
}

export default SidebarIcon;
